import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.GenderFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'gender'
  alias: "Gender"
  facetName: 'enhanced_gender'
  selectAll: true
  visibleInMyHistorySession: false

  getAppliedValues: () ->
    return @searchQuery.get('enhanced_gender')

  addFilter: (value) ->
    @searchQuery.addGender(value)